export default __webpack_public_path__ + "static/media/Ies_Zeraus.698ed5a0.png";